module.exports = __webpack_public_path__ + "static/media/vertisis-square.909ff791.svg";